import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { useRole } from '@/hooks/useRole'
import { BrandingProvider } from '@/contexts/BrandingContext'
import { NavShell } from '@/components/nav/NavShell'
import { AssistantPanelProvider } from '@/components/assistant/AssistantPanelProvider'

export function OperatorLayout() {
  const { status, provisioning, branding } = useRole()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (status !== 'resolved') return
    // Guard the redirect target too — without it this fires on every render of
    // /provisioning itself and the router thrashes.
    if (provisioning && pathname !== '/provisioning') {
      navigate('/provisioning', { replace: true })
    }
  }, [status, provisioning, pathname, navigate])

  return (
    <BrandingProvider branding={branding}>
      {/* NavShell wraps the Outlet, not each screen: the sidebar has to survive
          navigation, and only one route element renders at a time. The assistant
          panel provider sits at the same level for the same reason — the chat
          conversation must survive navigating between operator screens. */}
      <AssistantPanelProvider>
        <NavShell>
          <Outlet />
        </NavShell>
      </AssistantPanelProvider>
    </BrandingProvider>
  )
}
